import { render, staticRenderFns } from "./FormSuccessMessage.vue?vue&type=template&id=6bf29ec0&scoped=true&lang=html"
import script from "./FormSuccessMessage.vue?vue&type=script&lang=js"
export * from "./FormSuccessMessage.vue?vue&type=script&lang=js"
import style0 from "./FormSuccessMessage.vue?vue&type=style&index=0&id=6bf29ec0&prod&scoped=true&lang=css"
import style1 from "./FormSuccessMessage.vue?vue&type=style&index=1&id=6bf29ec0&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6bf29ec0",
  null
  
)

export default component.exports